// src/modules/app-views/_apps/applekkus/landingPages/pages/Init/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { dropdownParameters } from 'layouts/Pages/PageHeader/dropdownMenus';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const landingPagesInitMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [
      dropdownParameters,
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default landingPagesInitMenuButton;
